// 🟢 Dictionary แมประหัสนัมเบอร์เป็นชื่อประเภทเอกสารสิทธิ์
export const PARCEL_TYPE_MAP = {
    1: 'โฉนด',
    '2': 'น.ส.3',
    '3': 'น.ส.3ก.',
    '5': 'ตราจอง',
    '6': 'ที่สาธารณประโยชน์',
    '7': 'น.ส.ล.',
    '8': 'ใบจอง',
    '10': 'ที่ว่างเปล่า',
    '11': 'ที่ป่า',
    '12': 'ท.ค.',
    '13': 'ทางสาธารณประโยชน์',
    '14': 'คูน้ำสาธารณประโยชน์',
    '15': 'ที่วัด',
    '16': 'ที่ราชพัสดุ'
};

// 🟢 Array รายการตัวเลือกสำหรับเอาไป map() ใส่ <MenuItem> ใน Dropdown
export const PARCEL_TYPE_OPTIONS = Object.entries(PARCEL_TYPE_MAP).map(([value, label]) => ({
    value,
    label
}));

// 🟢 Helper Function แปลงรหัสเป็นชื่อ (ป้องกันกรณีหาไม่เจอแล้วระเบิด)
export const getParcelTypeName = (typeCode) => {
    console.log(typeCode)
    if (!typeCode) return '-';
    return PARCEL_TYPE_MAP[String(typeCode)] || '-';
};